export const CHARACTERS_PER_MINUTE = 150;
export const AVG_MINUTES_PER_CHARACTER = 4.8;
export const RATE_CREDITS_PER_CHARACTER_ADVANCED = 2;
export const RATE_CREDITS_PER_CHARACTER_PREMIUM = 3;
